import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useCookies } from "react-cookie";
import { COOKIESPREFIX } from "../../../config";
import { validateEmail } from "../../../utils/util";
import { merchantLoginWithPassword } from "../../../services/users";
import { fetchEventComments, merchantAddRemarks, merchantChangeParticipationStatus, merchantFetchParticipationWithUserData } from '../../../services/events';
import PageSelector from '../../../components/PageSelector';
import LoadingPage from "../../../components/Loading";
import DropdownMenu from '../components/Dropdown'
import { utils, writeFile } from 'xlsx';

const limit = 10

function Page(props) {
    const { id: eventId } = useParams();

    const [isloading, setisloading] = useState(false);


    const [searchParams, setSearchParams] = useSearchParams();
    const [totalItem, setTotalItem] = useState(1)
    const totalPage = Math.ceil(totalItem / limit) || 1
    const [data, setData] = useState([])
    const page = parseInt(searchParams.get('page')) || 1
    const filterComment = searchParams.get('comment')
   
    //
    const handleSearchComment = (e) => { setSearchParams({ page: 1, comment: e.target.value }) }
    useEffect(() => {
        if (!props.token.isLogin) return
        const timer = setTimeout(fetchData, 500)
        return () => {
            clearTimeout(timer)
        }
    }, [searchParams, props.token])
    async function fetchData() {
        const filter = { eventId }
        if (filterComment) filter.comment = { "$regex": filterComment, "$options": 'i' }
       
        const res = await fetchEventComments(filter, { limit, skip: limit * (page - 1), sort: { _id: -1 } })
        if (res.errno) return
        setTotalItem(res.count)
        setData(res.result)

        const toPage = Math.ceil(res.count / limit) || 1
        if (page > toPage) handleParamChange('page', 1)
    }
    const handleSelectPage = (p) => () => {
        if (p > totalPage || p < 1) return;
        searchParams.delete('page')
        searchParams.set('page', p)
        setSearchParams(searchParams)
    }
    function handleParamChange(key, val) {
        searchParams.delete(key)
        if (val !== '') searchParams.set(key, val)
        setSearchParams(searchParams)
    }



    return (
        <div className="w-full h-full flex flex-col items-center justify-start bg-[#ddd] overflow-hidden p-[16px]">

            <div className="w-full flex flex-row gap-[16px]">
                <input onChange={handleSearchComment} placeholder="按評論搜尋" className="p-[4px] rounded-[4px]" />
                {/* <div className="flex flex-row flex-1 justify-end items-center" style={{ gap: 8 }}>
                    <DropdownMenu value={filterType} select={selectFilter} options={['全部', '待批准', '已核准', '已拒絕']} />
                </div> */}
            </div>
            <div className="flex-1 w-full flex flex-col py-[16px]" style={{ overflowY: 'auto' }}>
                {/*Header */}
                <div className="flex flex-row justify-betwen items-center w-full text-[12px] text-[#6E604C] font-[700] pb-[8px]" style={{ borderBottom: '2px solid #6E604C' }}>
                    <div className="w-[24px] h-[24px] flex flex-row items-center">
                        <input type="checkbox" checked={data?.every(p => p.isSelected)} onChange={(e) => {
                            let isAllSelected = data?.every(p => p.isSelected)
                            let d = [...data];
                            for (let i of data) {
                                i.isSelected = isAllSelected ? false : true
                            }
                            setData(d)
                        }} />
                    </div>
                    <div className="flex-1">性別(Gender)</div>
                    <div className="flex-1">姓(Surname)</div>
                    <div className="flex-1">名(Firstname)</div>
                    <div className="flex-[1]">公司/機構名稱(Company)</div>
                    <div className="flex-[1]">職務(Title)</div>
                    <div className="flex-[3]">評論內容(Comments)</div>
                    <div className="flex-[1]">評論時間</div>
                </div>

                <div className="flex-1 w-full flex flex-col mt-[16px]">
                    {data?.map((item, index) =>
                        <div key={item?._id} className="flex flex-row justify-betwen items-center w-full text-[12px] text-[black] font-[400] py-[8px]" style={{ borderBottom: '.5px solid #fff', backgroundColor: item.isSelected ? '#ccc' : 'transparent' }}>
                            <div className="w-[24px] h-[24px] flex flex-row items-center">
                                <input type="checkbox" checked={item.isSelected} onChange={(e) => {
                                    let d = [...data];
                                    for (let i of data) {
                                        if (i._id === item._id) i.isSelected = !i.isSelected
                                    }
                                    setData(d)
                                }} />
                            </div>
                            <div className="flex-1">{item?.user?.[0]?.data?.gender || ''}</div>
                            <div className="flex-1">{item?.use?.[0]?.data?.lastname || ''}</div>
                            <div className="flex-1">{item?.user?.[0]?.data?.firstname || ''}</div>
                            <div className="flex-[1]">{item?.user?.[0]?.data?.company || ''}</div>
                            <div className="flex-[1]">{item?.user?.[0]?.data?.position || ''}</div>
                            <div className="flex-[3] font-bold text-[16px] text-[#6E604C]">{item?.comment || ''}</div>
                            <div className="flex-[1]">{new Date(item?.createDate).toLocaleString()}</div>
                        </div>
                    )}
                    {data?.length === 0 && <div className="w-full h-full flex flex-col items-center justify-center">
                        <div className="text-[16px] text-[#6E604C] font-[700]">沒有評論</div>
                        <div className="text-[12px] text-[#6E604C] font-[400]">請稍後再試</div>
                    </div>}
                </div>
            </div>


            <PageSelector page={page} total={totalItem} totalPage={totalPage} handleSelectPage={handleSelectPage} />
    
            {isloading && <LoadingPage />}
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)




const ReloadSvg = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={15}
        height={17}
        fill="none"
        {...props}
    >
        <path
            fill="#7A7A7A"
            d="M14.445 7.931a7.07 7.07 0 0 0-1.071-2.545 7.16 7.16 0 0 0-1.922-1.922 7.077 7.077 0 0 0-4-1.214V.667L4.31 3.039l3.144 2.373v-1.58a5.505 5.505 0 0 1 3.113.943 5.539 5.539 0 0 1 .82 8.507 5.557 5.557 0 0 1-2.797 1.508 5.641 5.641 0 0 1-2.231 0 5.538 5.538 0 0 1-4.42-5.424H.354c.001 1.418.425 2.804 1.218 3.98a7.192 7.192 0 0 0 1.92 1.92 7.078 7.078 0 0 0 3.98 1.217 7.128 7.128 0 0 0 5.902-3.139 7.08 7.08 0 0 0 1.215-3.978c0-.482-.049-.963-.145-1.435Z"
        />
    </svg>
)